import type { DependencyList, RefObject } from "react";

import { useEffect, useRef } from "react";

export const useObservedRef = <Element extends HTMLElement>(
  callback: VoidFunction,
  dependencyList: DependencyList
): RefObject<Element> => {
  const ref = useRef<Element>(null);

  useEffect(() => {
    const mutationObserver = new MutationObserver(callback);
    const resizeObserver = new ResizeObserver(callback);
    const node = ref.current;
    if (node) {
      node.addEventListener("scroll", callback, { passive: true });
      mutationObserver.observe(node, {
        attributes: true,
        childList: true,
        subtree: true,
      });
      resizeObserver.observe(node);
    }
    return () => {
      if (node) {
        node.removeEventListener("scroll", callback);
      }
      mutationObserver.disconnect();
      resizeObserver.disconnect();
    };
  }, dependencyList);

  return ref;
};
